import {Button, Menu, MenuHandler, MenuItem, MenuList, Typography} from "@material-tailwind/react";
import React, {useContext, useEffect, useState} from "react";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {getServiceFieldAgentBranchFees} from "../../services/agent_branch_fee/agent_branch_fee";
import {ServiceContext} from "../service/service_context";
import {BsClockFill, BsCurrencyDollar} from "react-icons/bs";

export function AgentPanelServiceMenu({agentId, fieldId, branch_id, agent_name}) {

  const {setLastDataRefresh, service, setService, setStep, setModalOpen, setBranchInfo} = useContext(ServiceContext);

  const [fieldAgentBranchFees, setFieldAgentBranchFees] = useState([]);
  const [openMenu, setOpenMenu] = useState(branch_id ? true : false);
  const [dataLoaded, setDataLoaded] = useState(false);

  function reOrderBranches(field_agent_branch_fee) {
    let selectedBranch;
    for (let branch of field_agent_branch_fee) {
      if (branch.id === parseInt(branch_id)) {
        selectedBranch = branch;
        break;
      }
    }

    if (!selectedBranch) {
      return
    }

    const index = field_agent_branch_fee.indexOf(selectedBranch);
    field_agent_branch_fee.splice(index, 1);
    // Insert the selected agent at the first position of the list
    field_agent_branch_fee.unshift(selectedBranch);
    return field_agent_branch_fee;
  }

  async function getAgentFieldData() {
    setDataLoaded(false);
    const data = new URLSearchParams({
      field_id: fieldId,
      agent_id: agentId,
    }).toString()
    const result = await getServiceFieldAgentBranchFees(data);
    if (result.status === 200) {
      let {field_agent_branch_fee} = result.data;
      if (branch_id && field_agent_branch_fee) {
        field_agent_branch_fee = reOrderBranches(field_agent_branch_fee)
      }
      setFieldAgentBranchFees(field_agent_branch_fee)
      setDataLoaded(true);
    }
  }

  useEffect(() => {
    if (openMenu) {
      getAgentFieldData();
    }
  }, [openMenu]);

  useEffect(() => {
    setOpenMenu(branch_id ? true : false);
  }, [branch_id]);

  return (
    <Menu placement="bottom" open={openMenu} handler={setOpenMenu}>
      <MenuHandler>
        <Button className="w-fit" variant={`${dataLoaded && openMenu ? "gradient" : "outlined"}`}
                onClick={() => {
                  setOpenMenu(!openMenu)
                }}>
          استعلام قیمت خدمات
        </Button>
      </MenuHandler>
      <MenuList className="flex flex-col max-h-72">
        {dataLoaded && fieldAgentBranchFees.map(({
                                                   id,
                                                   branch_title,
                                                   consensual,
                                                   price,
                                                   min_price,
                                                   max_price,
                                                   period,
                                                   day,
                                                   min_day,
                                                   max_day,
                                                 }, index) => (
            <>
              <MenuItem className="flex flex-col py-2 pl-2 gap-y-2"
                        onClick={() => {
                          // save(id)
                          setService(service => ({
                            ...service,
                            agent_name: agent_name,
                            agent_id: agentId
                          }))
                          setStep("confirmation")
                          setModalOpen(true)
                          setBranchInfo(fieldAgentBranchFees[index])
                          setOpenMenu(false)

                        }}
              >
                <div className="flex flex-row">
                  <Typography variant="h6" color="gray" className="font-semibold">
                    {`گرایش: ${branch_title}`}
                  </Typography>
                </div>
                <div className="flex flex-row">
                  {!consensual ?
                    <Typography
                      className="flex items-center gap-1 text-sm font-medium text-blue-gray-500">
                      <BsCurrencyDollar/>
                      {`هزینه خدمات: ${persianNumberFormat(price, true)} ریال`}
                    </Typography>
                    :

                    <Typography
                      className="flex items-center gap-1 text-sm font-medium text-blue-gray-500">
                      <BsCurrencyDollar/>
                      {`هزینه خدمات: از ${persianNumberFormat(min_price, true)} تا ${persianNumberFormat(max_price, true)} ریال`}
                    </Typography>
                  }
                </div>
                <div className="flex flex-row gap-1">
                  {!period ?
                    <Typography
                      className="flex items-center gap-1 text-sm font-medium text-blue-gray-500">
                      <BsClockFill/>
                      {`مدت: ${day !== null ? persianNumberFormat(day) : " - "} روز`}
                    </Typography>
                    :
                    <Typography
                      className="flex items-center gap-1 text-sm font-medium text-blue-gray-500">
                      <BsClockFill/>
                      {`مدت: از ${persianNumberFormat(min_day)} تا ${persianNumberFormat(max_day)} روز`}
                    </Typography>
                  }
                </div>
              </MenuItem>
              {index !== fieldAgentBranchFees.length - 1 &&
                <hr className=""/>
              }
            </>
          )
        )}
        {!dataLoaded &&
          <MenuItem className="flex flex-col items-center gap-4 py-2 pl-2 pr-8">
            <div className="flex flex-row gap-1">
              <Typography variant="small" color="gray" className="font-semibold">
                در حال دریافت اطلاعات ....
              </Typography>
            </div>

          </MenuItem>
        }
      </MenuList>
    </Menu>
  )
    ;
}
